module.exports = __webpack_public_path__ + "img/AgeUpL3_ua.5dd96931.webp";